import { render, staticRenderFns } from "./config-third.vue?vue&type=template&id=b3e2d584&"
import script from "./config-third.vue?vue&type=script&lang=ts&"
export * from "./config-third.vue?vue&type=script&lang=ts&"
import style0 from "./config-third.vue?vue&type=style&index=0&module=true&lang=stylus&"
import style1 from "./config-third.vue?vue&type=style&index=1&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports